module.exports = __webpack_public_path__ + "media/images/webpage/coupons/coupon/howto-step4-1d887fbed2a29c8021cd6bd477571ac6.svg";